import { sortBy } from 'lodash';
import moment from 'moment';

function getForcastDataByStorage(key) {
  var item = getLocalStorageJson(key);
  if (!window.GLOBAL_CONFIG) return null; // console.log((moment().unix() - item.updateTime) <= GLOBAL_CONFIG.rainfallCacheTime, GLOBAL_CONFIG.rainfallCacheTime)

  if (item && moment().unix() - item.updateTime <= window.GLOBAL_CONFIG.rainfallCacheTime) {
    return item;
  }

  localStorage.removeItem(key);
  return null;
}

function getLocalStorageJson(key) {
  var itemString = localStorage.getItem(key);
  return JSON.parse(itemString);
}

function setLocalStorageJson(k, v) {
  localStorage.setItem(k, JSON.stringify(v));
}

export default {
  namespace: true,
  state: {
    rainfallLayerGroup: null,
    mousePoint: null,
    // 缓存未来2小时降雨数据
    forcast2HourData: getForcastDataByStorage('rainfall-forcast') || {
      updateTime: '',
      data: []
    }
  },
  mutations: {
    SET_RAINFALL_LAYER_GROUP: function SET_RAINFALL_LAYER_GROUP(state, layerGroup) {
      state.rainfallLayerGroup = layerGroup;
    },
    SET_MOUSE_POINT: function SET_MOUSE_POINT(state, mousePoint) {
      state.mousePoint = mousePoint;
    },
    SET_FORCAST_HOUR_DATA: function SET_FORCAST_HOUR_DATA(state, data) {
      setLocalStorageJson('rainfall-forcast', data);
      state.forcast2HourData = data;
    }
  },
  getters: {
    // 获取原始数据
    getForcastData: function getForcastData(state) {
      return state.forcast2HourData;
    },
    // 获取未来2小时已经排序好的数据
    getForcastReData: function getForcastReData(state) {
      return sortBy(state.forcast2HourData.data, function (o) {
        return o.value;
      }).reverse();
    },
    // 检测数据是否过期
    checkForcastData: function checkForcastData(state) {
      var forcast = state.forcast2HourData;

      if (forcast.updateTime && forcast.updateTime - moment().unix() <= window.GLOBAL_CONFIG.rainfallCacheTime) {
        return true;
      } else {
        return false;
      }
    }
  }
};